import React, { useState } from 'react';

import { useSnrwbCore } from '../../../../common/hooks/useSnrwbCore';
import { ReportInspectedOrganizations } from '../../../../common/types/ReportTypes';
import { ReportByOrganizationType } from '../../../components/ReportByOrganizationType/ReportByOrganizationType';
import { Filter, FilterReportData } from '../../../components/Reports/Filter';
import abbreviationLegend from '../../../../common/abbreviationLegend';

export const ReportInspectedOrganizationByProductsCPRView: React.FC = () => {
  const snrwbApi = useSnrwbCore();
  const [filterApplied, setFilterApplied] = useState(false);
  const [usedFilter, setUsedFilter] = useState<FilterReportData | undefined>(
    {},
  );
  const [data, setData] = useState<ReportInspectedOrganizations>({
    details: {},
    sum: {},
  });

  const onSearch = (filter?: FilterReportData) => {
    setFilterApplied(true);
    setUsedFilter(filter);
    snrwbApi.reports
      .reportInspectedOrganizationsByProducts(true, filter)
      .then(dataReports => {
        setData(dataReports);
      });
  };

  return (
    <>
      <Filter
        onSearch={onSearch}
        reportName="Skontrolowane wyroby CPR u podmiotów"
      />
      <ReportByOrganizationType
        data={data}
        reportName1="skontrolowane wyroby CPR, ogółem (suma poszczególnych)"
        reportName2="liczba skontrolowanych wyrobów CPR u producentów"
        reportName3="liczba skontrolowanych wyrobów CPR u importerów"
        reportName4="liczba skontrolowanych wyrobów CPR u sprzedawców"
        reportName5="liczba skontrolowanych wyrobów CPR u upoważnionych przedstawicieli producentów"
        filterApplied={filterApplied}
        usedFilter={usedFilter}
        reportName="Skontrolowane wyroby CPR u podmiotów"
        legend={abbreviationLegend('inspectedProducts')}
      />
    </>
  );
};
